import { c as _c } from "react/compiler-runtime";
import { BlacksmithLogomarkAnimationSVG } from "@/components/BlacksmithLogoSVG";
import { SessionSkeleton } from "@/components/codesmith/SessionSkeleton";
import { RAIL_WIDTH } from "@/components/sidebar/railConstants";
import { isCodesmithPath } from "@/components/sidebar/useActiveApp";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { useDashboardRouter as useRouter } from "@/hooks/useDashboardRouter";
import { useCodesmithSurface } from "@/lib/codesmithSurface";

// 28px clears the macOS traffic lights of a `titleBarStyle: "hiddenInset"`
// window and gives the frameless window something to drag by.
export function DesktopTitleBar() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden={true} className="h-7 shrink-0 bg-sidebar shadow-[inset_0_-1px_0_0_var(--color-border)] [-webkit-app-region:drag]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}

/**
 * The window's drag handle for full-screen states that render without
 * DesktopTitleBar (auth loading, signed out, org access denied).
 */
export function DesktopDragRegion() {
  const $ = _c(1);
  const desktop = useCodesmithSurface(null) === "desktop";
  if (!desktop) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden={true} className="fixed inset-x-0 top-0 z-50 h-7 [-webkit-app-region:drag]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}

// `contain: layout` makes this box the containing block for fixed-position
// descendants, so SettingsSidebar's `fixed inset-y-0` starts below the title
// bar instead of under the traffic lights.
export const DESKTOP_BODY_CLASS = "relative min-h-0 flex-1 [contain:layout]";

/** AuthProvider's loading state, shaped like DesktopSidebarLayout. */
export function DesktopLayoutSkeleton() {
  const $ = _c(4);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DesktopTitleBar />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="h-full shrink-0 bg-sidebar shadow-[inset_-1px_0_0_0_var(--color-border)]" style={{
      width: RAIL_WIDTH
    }} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== router.pathname) {
    t2 = <div className="flex h-dvh flex-col">{t0}<SidebarProvider className={DESKTOP_BODY_CLASS}><div className="flex flex-1 overflow-hidden">{t1}<SidebarInset className="flex-1 bg-transparent! overflow-hidden">{isCodesmithPath(router.pathname) ? <SessionSkeleton /> : <div className="flex h-full items-center justify-center"><div className="w-32 h-32"><BlacksmithLogomarkAnimationSVG /></div></div>}</SidebarInset></div></SidebarProvider></div>;
    $[2] = router.pathname;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}